import { defineComponent as _defineComponent } from 'vue'
import { DataInstance } from '@busy-human/gearbox';
import { InviteLinks } from '@busy-human/opt-library';
import OptOffer from '@/components/opt-offer.vue';
import VQrCode from '@/components/QrCode.vue'
import { computed, ref, onBeforeMount } from 'vue';

type Props = {
    instance: DataInstance<InviteLinks.Model>
}
type Emits = {
    (e: 'restart'): void,
    (e: 'updateInvite'): void
    (e: 'showToast', message: 'copy' | 'share'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'invite-send',
  props: {
    instance: null
  },
  emits: ["restart", "updateInvite", "showToast"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'restart'): void,
    (e: 'updateInvite'): void
    (e: 'showToast', message: 'copy' | 'share'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    instance: DataInstance<InviteLinks.Model>
}






const offerUrl = computed(() => `${window.location.protocol}//${window.location.host}/#/invite/${props.instance?.link}`)

const preview = ref(false);

const noScroll = ref(false)

const meetingLink = ref()
const previewString = ref("Preview Opt invite before you send")

const copyToClipboard = () =>{
    emit('showToast', 'copy')
    meetingLink.value.focus()
    meetingLink.value.select()
    document.execCommand('copy');
}

const __returned__ = { props, emit, offerUrl, preview, noScroll, meetingLink, previewString, copyToClipboard, DataInstance, InviteLinks, OptOffer, VQrCode, computed, ref, onBeforeMount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})